// import {Outlet, Navigate} from "react-router-dom";

// import {selectIsAdmin, selectToken} from "../redux/slices/authSlice";
// import {useSelector} from "react-redux";

// const PrivateRoutes = () => {

//     const token = useSelector(selectToken);
//     const isAdmin = useSelector(selectIsAdmin)

//     return (

//         (token && isAdmin) ?  <Outlet/> : <Navigate to='/login'/>
//     )

// }

// export default PrivateRoutes;

import { Outlet, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  selectIsAdmin,
  selectToken,
  selectAuthInitialized,
} from "../redux/slices/authSlice";

const PrivateRoutes = () => {
  const token = useSelector(selectToken);
  const isAdmin = useSelector(selectIsAdmin);
  const initialized = useSelector(selectAuthInitialized);

  if (!initialized) {
    return <Outlet />;
  }

  return token && isAdmin ? <Outlet /> : <Navigate to="/login" replace />;
};

export default PrivateRoutes;
